import { useAppTranslation } from '@hooks/useAppTranslation';
import { SizableText } from 'tamagui';

/**
 * AppName component displays the application title with translation.
 */
export function AppName(): React.ReactNode {
  const { t } = useAppTranslation();

  return (
    <SizableText fontFamily="$bold" size="$1">
      {t('navigation.appTitle')}
    </SizableText>
  );
}
